module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.isForum) ? _c('forum-header') : _c('v-header', {
    attrs: {
      "account": _vm.account,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "bkloading",
      rawName: "v-bkloading",
      value: ({
        isLoading: _vm.globalState
      }),
      expression: "{isLoading: globalState}"
    }],
    staticClass: "bk-content"
  }, [_c('router-view', {
    attrs: {
      "account": _vm.account,
      "user": _vm.user
    },
    on: {
      "openInformationPopup": _vm.openInformationPopup
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isShowNeedPop) ? _c('getMedalPop', {
    attrs: {
      "isNeedPopData": _vm.isNeedPopData,
      "isShowNeedPop": _vm.isShowNeedPop
    },
    on: {
      "update:isNeedPopData": function($event) {
        _vm.isNeedPopData = $event
      },
      "update:is-need-pop-data": function($event) {
        _vm.isNeedPopData = $event
      },
      "update:isShowNeedPop": function($event) {
        _vm.isShowNeedPop = $event
      },
      "update:is-show-need-pop": function($event) {
        _vm.isShowNeedPop = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "qd-fixed-wrapper"
  }, [_c('ul', {
    staticClass: "operate-wrapper"
  }, [_c('li', {
    staticClass: "operate-btn",
    on: {
      "click": function($event) {
        return _vm.skip('https://bk.tencent.com/docs/')
      }
    }
  }, [_c('i', {
    staticClass: "icon-help"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("文档中心")])]), _vm._v(" "), _c('li', {
    staticClass: "operate-btn",
    on: {
      "click": _vm.onFeedback
    }
  }, [_c('i', {
    staticClass: "icon-comment",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("社区提问")])]), _vm._v(" "), _c('li', {
    staticClass: "operate-btn",
    on: {
      "click": function($event) {
        return _vm.skip('https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump-market.html?linkType=0&env=ol&kfuin=3009071079&fid=1082&key=37bdc52f7d2e4d5684a3dfcb16dd7b88&cate=1&source=&isLBS=&isCustomEntry=&type=16&ftype=1&_type=wpa&qidian=true')
      }
    }
  }, [_c('i', {
    staticClass: "doc-icon icon-qq-i"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("在线咨询")])]), _vm._v(" "), _c('li', {
    staticClass: "operate-btn"
  }, [_c('el-popover', {
    attrs: {
      "placement": "left",
      "trigger": "hover",
      "popper-class": "public-pop"
    }
  }, [_c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "icon-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("公众号")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": require("./images/video/Qr_code.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫码关注")]), _vm._v(" "), _c('p', [_vm._v("获取更多资讯")])])])], 1)])])], 1), _vm._v(" "), (_vm.isInformationPopup || _vm.isWxPopup) ? _c('information', {
    attrs: {
      "information-popup": _vm.isInformationPopup,
      "wx-popup": _vm.isWxPopup,
      "downloadNeed": _vm.downloadNeed,
      "storeUserInfo": _vm.storeUserInfo
    },
    on: {
      "closeInfoBox": _vm.closeInfoBox
    }
  }) : _vm._e(), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0f7cb894!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = vhiw
// module chunks = 15